module.exports = __webpack_public_path__ + "f3eca93dd5b9291e641c7e5d12bb63e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/ComeBack/assets/sec-4/sephora.jpg
// module id = ./app/containers/StaticPage/ComeBack/assets/sec-4/sephora.jpg
// module chunks = 40